(function (root, factory) {
  var api = factory(root)
  if (typeof module === 'object' && module.exports) module.exports = api
  else root.WTXFirstOrderStarterGuide = api
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict'
  var previousFocus = null
  var bound = new WeakSet()
  var printStyles = 'body{margin:32px auto;padding:0 24px;max-width:800px;color:#24392e;background:white;font:15px/1.55 Arial,sans-serif}h1,h2,h3{font-family:Georgia,serif;font-weight:400;line-height:1.15}h1{font-size:40px}h2{font-size:27px;margin:24px 0 14px}h3{font-size:21px}.hero{padding-bottom:12px}.lead{font-size:17px}.kicker,.source,.small{font-size:12px}.chapter{border-top:1px solid #ccc;padding:16px 0}.chapter>summary{list-style:none}.toggle,.wsg-jumps{display:none!important}.chapter>summary h2{margin:0 0 14px}.quick,.wsg-order,.note{background:#f1f4ec;padding:20px;margin:20px 0;border:1px solid #d9d2c4}.check{display:flex;gap:10px;margin:10px 0}.check input{width:17px;height:17px}.pack-grid,.videos{display:grid;grid-template-columns:1fr 1fr;gap:16px}.pack-grid>div{border:1px solid #ccc;padding:14px}.pack-grid strong{display:block;font-size:25px}.pack-grid span{font-size:14px}.day{border-left:2px solid #b7d0ba;padding-left:18px}.contact{display:flex;gap:20px;flex-wrap:wrap}.video-link{display:block;padding:12px;border:1px solid #ccc;color:inherit}.video-link small{display:block}.play{display:none}[data-wsg-order-text],[data-wsg-notes-text]{white-space:pre-line;overflow-wrap:anywhere}.writing-lines{height:90px;background:repeating-linear-gradient(to bottom,transparent 0,transparent 28px,#ccc 29px,transparent 30px)}[hidden]{display:none!important}a{color:inherit;overflow-wrap:anywhere}.print-controls{display:flex;gap:15px;align-items:center;margin-bottom:28px}.print-controls button{min-height:44px;padding:10px 18px;background:#dce8d9;border:1px solid #82977f;border-radius:5px;font:700 14px Arial;cursor:pointer}@media print{@page{size:letter;margin:.65in}body{margin:0;padding:0;max-width:none;font-size:10.5pt}.print-controls{display:none}h1{font-size:30pt}h2{font-size:21pt;break-after:avoid}h3{font-size:15pt;break-after:avoid}.day,.note,.pack-grid,.quick,.video-link{break-inside:avoid}.chapter>summary{break-after:avoid}.video-link:after{content:attr(href);display:block;font-size:7pt;font-weight:400;overflow-wrap:anywhere}.video-link small{display:none}.videos{display:block}.video-link{border:0;padding:5px 0}.source{font-size:8pt}.source a:after{content:" (" attr(href) ")";overflow-wrap:anywhere;font-size:7pt}.wsg-order{break-inside:avoid}}'

  function dialog() {
    return root.document && root.document.getElementById('wtx-first-order-starter-guide')
  }

  function text(value) {
    return typeof value === 'string' ? value : ''
  }

  function status(node, message) {
    var element = node.querySelector('[data-wsg-status]')
    if (element) element.textContent = message || ''
  }

  function close() {
    var node = dialog()
    if (!node) return false
    if (typeof node.close === 'function') node.close()
    else node.removeAttribute('open')
    restoreFocus()
    return true
  }

  function restoreFocus() {
    if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus()
    previousFocus = null
  }

  function printGuide(node) {
    var preview
    try { preview = root.open('', '_blank') } catch (_) {}
    if (!preview) {
      status(node, node.dataset.printError)
      return false
    }
    try {
      preview.opener = null
      var doc = preview.document
      doc.open()
      doc.write('<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body></body></html>')
      doc.close()
      doc.title = node.dataset.printTitle || 'WTX'
      var style = doc.createElement('style')
      style.textContent = printStyles
      doc.head.appendChild(style)
      var controls = doc.createElement('div')
      controls.className = 'print-controls'
      var button = doc.createElement('button')
      button.type = 'button'
      button.textContent = node.querySelector('[data-wsg-print]').textContent
      button.addEventListener('click', function () { preview.print() })
      controls.appendChild(button)
      var hint = doc.createElement('p')
      hint.textContent = node.dataset.printReady || ''
      controls.appendChild(hint)
      doc.body.appendChild(controls)
      var copy = doc.importNode(node.querySelector('[data-wsg-content]'), true)
      Array.from(copy.querySelectorAll('details')).forEach(function (item) { item.open = true })
      Array.from(copy.querySelectorAll('.wsg-jumps,.wsg-downloads')).forEach(function (item) { item.remove() })
      doc.body.appendChild(copy)
      preview.focus()
      status(node, '')
      return true
    } catch (_) {
      try { preview.close() } catch (_) {}
      status(node, node.dataset.printError)
      return false
    }
  }

  function bind(node) {
    if (bound.has(node)) return
    bound.add(node)
    node.addEventListener('close', restoreFocus)
    node.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('button') : null
      if (!target || !node.contains(target)) return
      if (target.hasAttribute('data-wsg-close')) close()
      if (target.hasAttribute('data-wsg-print')) printGuide(node)
      if (target.hasAttribute('data-wsg-jump')) {
        var section = node.querySelector('#' + target.getAttribute('data-wsg-jump'))
        if (section) {
          section.open = true
          section.scrollIntoView({ behavior: 'auto', block: 'start' })
          var summary = section.querySelector('summary')
          if (summary) summary.focus({ preventScroll: true })
        }
      }
    })
  }

  function open(input) {
    var node = dialog()
    if (!node || typeof node.showModal !== 'function') return false
    input = input || {}
    var order = text(input.orderSummary)
    var notes = text(input.notes)
    var orderBox = node.querySelector('[data-wsg-order]')
    var orderText = node.querySelector('[data-wsg-order-text]')
    var notesBox = node.querySelector('[data-wsg-notes]')
    var notesText = node.querySelector('[data-wsg-notes-text]')
    if (!orderBox || !orderText || !notesBox || !notesText) return false
    orderText.textContent = order
    notesText.textContent = notes
    orderBox.hidden = !order && !notes
    notesBox.hidden = !notes
    notesBox.open = false
    status(node, '')
    bind(node)
    if (!node.open) previousFocus = root.document.activeElement
    try {
      if (!node.open) node.showModal()
      var scrolling = node.querySelector('[data-wsg-content]')
      if (scrolling) scrolling.scrollTop = 0
      var heading = node.querySelector('#wsg-title')
      if (heading) heading.focus({ preventScroll: true })
      return true
    } catch (_) { return false }
  }

  return { open: open, close: close }
})
